export default {"src":"/_next/static/media/turkeyiconblack.34ec29ab.svg","height":64,"width":64};